module.exports = __webpack_public_path__ + "img/db93d17.jpg";